<template>
  <div id="metocean-layer">
  </div>
</template>

<script>
import _ from 'lodash'
import {createNamespacedHelpers} from "vuex";

// Store
const {
  mapActions: mapActionsOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
  mapState: mapStateOfLiveMap,
  mapGetters: mapGettersOfLiveMap
} = createNamespacedHelpers("liveMap");

// Mixins
import {TyphoonMixin} from "@/mixins";

export default {
  name: "MetoceanLayer",
  mixins: [TyphoonMixin],
  data() {
    return {
      beforeLayerId: 'PlotTextLayer'
    };
  },
  props: {
    map: Object,
    isReady: {type: Boolean, default: false},
    mapEvent: String
  },
  computed: {
    ...mapGettersOfLiveMap([]),
    ...mapStateOfLiveMap({
      selectedMetoceanElement: state => state.selectedMetoceanElement,
      updateMetoceanSourceLayer: state => state.updateMetoceanSourceLayer,
      showMetoceanValue: state => state.showMetoceanValue,
      showMetoceanGrid: state => state.showMetoceanGrid,
      showWeatherMenu: state => state.showWeatherMenu,
    }),
  },
  watch: {
    mapEvent() {
    },
    async isReady() {
      if (this.isReady) {
        if (this.showWeatherMenu) {
          await this.setMetoceanSourceLayer(this.updateMetoceanSourceLayer)
        }
      }
    },
    updateMetoceanSourceLayer(val) {
      if (val.isUpdate) {
        this.updateSourceLayer(this, val)
      } else {
        this.removeMetoceanSourceLayer(val.newSourceLayerId)
      }
    },
    showMetoceanValue(val) {
      this.setMetoceanValueVisibility(val)
    },
    showMetoceanGrid(val) {
      this.setMetoceanGridVisibility(val)
    }
  },
  methods: {
    ...mapActionsOfLiveMap([]),
    ...mapMutationsOfLiveMap([]),

    updateSourceLayer: _.throttle((self, val) => {
      self.setMetoceanSourceLayer(val)
    }, 100),

    setMetoceanValueVisibility(isShow) {
      let i = 0;
      while (i < 4) {
        if (this.map.getLayer(`metoceanTextLayer${i + 1}`)) {
          this.map.setLayoutProperty(
            `metoceanTextLayer${i + 1}`,
            'visibility',
            isShow ? "visible" : "none"
          );
        }
        i = (i + 1) | 0;
      }
    },

    setMetoceanGridVisibility(isShow) {
      let i = 0;
      while (i < 4) {
        if (this.map.getLayer(`metoceanWindGridLayer${i + 1}`)) {
          this.map.setLayoutProperty(
            `metoceanWindGridLayer${i + 1}`,
            'visibility',
            isShow ? "visible" : "none"
          );
        }
        if (this.map.getLayer(`metoceanWaveGridLayer${i + 1}`)) {
          this.map.setLayoutProperty(
            `metoceanWaveGridLayer${i + 1}`,
            'visibility',
            isShow ? "visible" : "none"
          );
        }
        if (this.map.getLayer(`metoceanCurrentGridLayer${i + 1}`)) {
          this.map.setLayoutProperty(
            `metoceanCurrentGridLayer${i + 1}`,
            'visibility',
            isShow ? "visible" : "none"
          );
        }
        i = (i + 1) | 0;
      }
    },

    async removeMetoceanSourceLayer(sourceLayerId) {
      let i = 0;
      while (i < 4) {
        if (this.map.getLayer(`metoceanIconLayer${i + 1}`)) this.map.removeLayer(`metoceanIconLayer${i + 1}`)
        if (this.map.getLayer(`metoceanTextLayer${i + 1}`)) this.map.removeLayer(`metoceanTextLayer${i + 1}`)
        if (this.map.getLayer(`metoceanWindGridLayer${i + 1}`)) this.map.removeLayer(`metoceanWindGridLayer${i + 1}`)
        if (this.map.getLayer(`metoceanWaveGridLayer${i + 1}`)) this.map.removeLayer(`metoceanWaveGridLayer${i + 1}`)
        if (this.map.getLayer(`metoceanCurrentGridLayer${i + 1}`)) this.map.removeLayer(`metoceanCurrentGridLayer${i + 1}`)
        i = (i + 1) | 0;
      }
      if (this.map.getSource(sourceLayerId)) this.map.removeSource(sourceLayerId)
    },

    async setMetoceanSourceLayer(val) {
      if (typeof val === "undefined") return
      await this.removeMetoceanSourceLayer(val.oldSourceLayerId)
      this.map.addSource(val.newSourceLayerId, {
        type: "vector",
        url: `mapbox://aidea.${val.newSourceLayerId}?fresh=true`
      });

      let i = 0;
      while (i < 4) {
        // Grid
        if (this.selectedMetoceanElement === "oceanWind") {
          this.map.addLayer({
            id: `metoceanWindGridLayer${i + 1}`,
            type: "fill",
            source: `${val.newSourceLayerId}`,
            "source-layer": `metocean_grid_${i + 1}`,
            layout: {
              "visibility": this.showMetoceanGrid ? "visible" : "none"
            },
            paint: {
              "fill-color": [
                "case",
                ["all", ['>=', ["to-number", ["get", "wind_speed"]], 0], ['<=', ["to-number", ["get", "wind_speed"]], 5]],
                ["rgba", 10, 71, 245, 0.7],
                ["all", ['>=', ["to-number", ["get", "wind_speed"]], 5.5], ['<=', ["to-number", ["get", "wind_speed"]], 10]],
                ["rgba", 86, 193, 238, 0.7],
                ["all", ['>=', ["to-number", ["get", "wind_speed"]], 10.5], ['<=', ["to-number", ["get", "wind_speed"]], 15]],
                ["rgba", 129, 184, 56, 0.7],
                ["all", ['>=', ["to-number", ["get", "wind_speed"]], 15.5], ['<=', ["to-number", ["get", "wind_speed"]], 20]],
                ["rgba", 250, 222, 75, 0.7],
                ["all", ['>=', ["to-number", ["get", "wind_speed"]], 20.5], ['<=', ["to-number", ["get", "wind_speed"]], 30]],
                ["rgba", 244, 180, 63, 0.7],
                ["all", ['>=', ["to-number", ["get", "wind_speed"]], 30.5], ['<=', ["to-number", ["get", "wind_speed"]], 40]],
                ["rgba", 235, 72, 40, 0.7],
                ["rgba", 111, 38, 157, 0.7],
              ],
            }
          }, this.beforeLayerId)
        } else if (this.selectedMetoceanElement === "oceanWave") {
          this.map.addLayer({
            id: `metoceanWaveGridLayer${i + 1}`,
            type: "fill",
            source: `${val.newSourceLayerId}`,
            "source-layer": `metocean_grid_${i + 1}`,
            layout: {
              "visibility": this.showMetoceanGrid ? "visible" : "none"
            },
            paint: {
              "fill-color": [
                "case",
                ["all", ['>=', ["to-number", ["get", "wave_height"]], 0], ['<=', ["to-number", ["get", "wave_height"]], 1.0]],
                ["rgba", 10, 71, 245, 0.7],
                ["all", ['>=', ["to-number", ["get", "wave_height"]], 1.05], ['<=', ["to-number", ["get", "wave_height"]], 2.0]],
                ["rgba", 37, 144, 241, 0.7],
                ["all", ['>=', ["to-number", ["get", "wave_height"]], 2.05], ['<=', ["to-number", ["get", "wave_height"]], 3.0]],
                ["rgba", 86, 193, 238, 0.7],
                ["all", ['>=', ["to-number", ["get", "wave_height"]], 3.05], ['<=', ["to-number", ["get", "wave_height"]], 4.0]],
                ["rgba", 129, 184, 56, 0.7],
                ["all", ['>=', ["to-number", ["get", "wave_height"]], 4.05], ['<=', ["to-number", ["get", "wave_height"]], 5.0]],
                ["rgba", 250, 222, 75, 0.7],
                ["all", ['>=', ["to-number", ["get", "wave_height"]], 5.05], ['<=', ["to-number", ["get", "wave_height"]], 6.0]],
                ["rgba", 244, 180, 63, 0.7],
                ["all", ['>=', ["to-number", ["get", "wave_height"]], 6.05], ['<=', ["to-number", ["get", "wave_height"]], 7.0]],
                ["rgba", 235, 72, 40, 0.7],
                ["rgba", 111, 38, 157, 0.7],
              ],
            }
          }, this.beforeLayerId)

        } else {
          this.map.addLayer({
            id: `metoceanCurrentGridLayer${i + 1}`,
            type: "fill",
            source: `${val.newSourceLayerId}`,
            "source-layer": `metocean_grid_${i + 1}`,
            layout: {
              "visibility": this.showMetoceanGrid ? "visible" : "none"
            },
            paint: {
              "fill-color": [
                "case",
                ["all", ['>=', ["to-number", ["get", "current_speed"]], 0], ['<=', ["to-number", ["get", "current_speed"]], 0.5]],
                ["rgba", 10, 71, 245, 0.7],
                ["all", ['>=', ["to-number", ["get", "current_speed"]], 0.6], ['<=', ["to-number", ["get", "current_speed"]], 1]],
                ["rgba", 37, 144, 241, 0.7],
                ["all", ['>=', ["to-number", ["get", "current_speed"]], 1.1], ['<=', ["to-number", ["get", "current_speed"]], 1.5]],
                ["rgba", 86, 193, 238, 0.7],
                ["all", ['>=', ["to-number", ["get", "current_speed"]], 1.6], ['<=', ["to-number", ["get", "current_speed"]], 2]],
                ["rgba", 129, 184, 56, 0.7],
                ["all", ['>=', ["to-number", ["get", "current_speed"]], 2.1], ['<=', ["to-number", ["get", "current_speed"]], 2.5]],
                ["rgba", 250, 222, 75, 0.7],
                ["all", ['>=', ["to-number", ["get", "current_speed"]], 2.6], ['<=', ["to-number", ["get", "current_speed"]], 3]],
                ["rgba", 244, 180, 63, 0.7],
                ["all", ['>=', ["to-number", ["get", "current_speed"]], 3.1], ['<=', ["to-number", ["get", "current_speed"]], 4]],
                ["rgba", 235, 72, 40, 0.7],
                ["rgba", 111, 38, 157, 0.7],
              ],
            }
          }, this.beforeLayerId)
        }

        // Point
        this.map.addLayer({
          id: `metoceanIconLayer${i + 1}`,
          type: "symbol",
          source: val.newSourceLayerId,
          "source-layer": `metocean_point_${i + 1}`,
          minzoom: 7,
          layout: {
            "icon-allow-overlap": true,
            "icon-ignore-placement": true,
            "visibility": this.showWeatherMenu ? "visible" : "none",
            "icon-image": [
              'case',
              ['==', this.selectedMetoceanElement, "oceanWind"],
              ['get', "wind_icon"],
              ['==', this.selectedMetoceanElement, "oceanWave"],
              "metocean_wave",
              "metocean_current"
            ],
            "icon-rotate": ['case',
              ['==', this.selectedMetoceanElement, "oceanWind"],
              ['get', "wind_direction"],
              ['==', this.selectedMetoceanElement, "oceanWave"],
              ['+', ["to-number", ["get", "wave_direction"]], 180],
              ['get', "current_direction"]
            ],
            "icon-size": [
              "interpolate", ["linear"], ["zoom"],
              4, 0.1,
              5, 0.2,
              10, 1.5
            ],
          }
        }, this.beforeLayerId);

        this.map.addLayer({
          id: `metoceanTextLayer${i + 1}`,
          type: "symbol",
          source: val.newSourceLayerId,
          "source-layer": `metocean_point_${i + 1}`,
          minzoom: 8,
          layout: {
            "visibility": this.showMetoceanValue ? "visible" : "none",
            "text-field": [
              'case',
              ['==', this.selectedMetoceanElement, "oceanWind"],
              ["concat", ['get', "wind_speed"], "m/s"],
              ['==', this.selectedMetoceanElement, "oceanWave"],
              ["concat", ['get', "wave_height"], "m\n", ['get', "wave_period"], "s"],
              ["concat", ['get', "current_speed"], "kn"],
            ],
            "text-anchor": "top",
            "text-size": 12,
            "text-offset": [0, 1.2],
          },
          paint: {
            "text-color": "#ffffff",
            "text-halo-color": "#000000",
            "text-halo-width": 1,
          }
        }, this.beforeLayerId);
        i = (i + 1) | 0;
      }
    }
  }
};
</script>

<style lang="scss">
</style>
